// @flow

import type { Address } from '@rover/react-lib/types';

export const getCityZipAddressLine = (address: Address): string =>
  `${address.city}, ${address.state} ${address.zip}, ${address.countryCode}`;

export const isStateRequired = (countryCode: string): boolean =>
  countryCode === 'US' || countryCode === 'CA';

export const isValidAddress = (address: Address): boolean =>
  !!(
    address &&
    address.city &&
    ((isStateRequired(address.countryCode) && address.state) ||
      !isStateRequired(address.countryCode)) &&
    address.addressLine1 &&
    address.zip
  );



// WEBPACK FOOTER //
// ../react-lib/src/utils/address.js